/**
 * Aparelho de mão (celular ou tablet)?
 *
 * Serve para decidir entre exibir o relatório num `<iframe>` e entregar o
 * arquivo direto: o Chrome no Android não renderiza PDF em iframe — a área fica
 * em branco —, então no celular o relatório é baixado em vez de exibido.
 *
 * Recebe o `navigator` (ou equivalente) para poder ser testado sem browser.
 */
const MOVEL = /Android|webOS|iPhone|iPod|IEMobile|Opera Mini|Mobile/i;

export default function ehCelular(navegador) {
  if (!navegador || !navegador.userAgent) return false;
  const { userAgent, maxTouchPoints } = navegador;

  if (MOVEL.test(userAgent)) return true;

  // iPad com iPadOS 13+ se anuncia como Macintosh; o que o denuncia é a tela
  // sensível ao toque. O critério exige o UA de Mac — um monitor touch no
  // Windows não entra aqui.
  const ehMac = /Macintosh/i.test(userAgent);
  return ehMac && Number(maxTouchPoints) > 1;
}
